import { differenceInDays } from "date-fns";
import { Bucket } from "../../api/indicators";

export const NO_VALUE_MARK = "-";

export const calculateDifferencePercentage = (numerator = 0, denominator = 0): number =>
  denominator ? (denominator - numerator) / denominator : NaN;

export const calculateCombinedPercentage = (
  current: number | undefined,
  compared: number | undefined
): { currentPercent: number; comparedPercent: number } => {
  const value = current ?? 0;
  const comparedValue = compared ?? 0;
  const total = value + comparedValue;

  return total > 0
    ? {
      currentPercent: (value / total),
      comparedPercent: (comparedValue / total),
    }
    : {
      currentPercent: NaN,
      comparedPercent: NaN,
    };
};

export const yAxisFormatter = (value: number) => {
    const abs = Math.abs(value);

    const formatter = (num: number) =>
        Number.isInteger(num)
            ? num.toString()
            : num.toFixed(1);

    if (abs >= 1_000_000_000_000_000) {
        return `${formatter(value / 1_000_000_000_000_000)}Q`;
    }

    if (abs >= 1_000_000_000_000) {
        return `${formatter(value / 1_000_000_000_000)}T`;
    }

    if (abs >= 1_000_000_000) {
        return `${formatter(value / 1_000_000_000)}B`;
    }

    if (abs >= 1_000_000) {
        return `${formatter(value / 1_000_000)}M`;
    }

    if (abs >= 1_000) {
        return `${formatter(value / 1_000)}K`;
    }

    return value.toString();
};


export const getBucketFromRange = (start: string | Date, end: string | Date): Bucket => {

  const startDate = new Date(start);
  const endDate = new Date(end);

  const days = differenceInDays(endDate, startDate);

  if (days < 2) return 'hour';
  if (days <= 14) return 'day';
  if (days > 14) return 'week';
  return 'day';
};

 export const getBucketFromComparedRanges = (
  start: string | Date,
  end: string | Date,
  compareStart: string | Date,
  compareEnd: string | Date
): Bucket => {

  const startDate = new Date(start);
  const endDate = new Date(end);
  const compareStartDate = new Date(compareStart);
  const compareEndDate = new Date(compareEnd);

  const currentDays = differenceInDays(endDate, startDate);
  const compareDays = differenceInDays(compareEndDate, compareStartDate);

  const days = Math.max(currentDays, compareDays);

  if (days < 2) return 'hour';
  if (days <= 14) return 'day';
  if (days > 14) return 'week';
  return 'day';
};

export const calculatePercentChanges = (
  current: number,
  compared: number
): { percent: number, percentCompared: number } => {
  if (!current && !compared) return { percent: NaN, percentCompared: NaN };

  const percent = current
    ? (current - compared) / current
    : NaN;

  const percentCompared = compared
    ? (compared - current) / compared
    : NaN;

  return { percent, percentCompared };
};
